var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50001 5.50004H7.33334V4.58337H14.6667V5.50004H16.5V4.58337H18.3333V7.33337H3.66668V4.58337H5.50001V5.50004ZM3.66668 9.16671V18.3334H18.3333V9.16671H3.66668ZM7.33334 2.75004H14.6667V1.83337H16.5V2.75004H18.3333C19.3459 2.75004 20.1667 3.57085 20.1667 4.58337V18.3334C20.1667 19.3459 19.3459 20.1667 18.3333 20.1667H3.66668C2.65415 20.1667 1.83334 19.3459 1.83334 18.3334V4.58337C1.83334 3.57085 2.65415 2.75004 3.66668 2.75004H5.50001V1.83337H7.33334V2.75004Z",
    fill: "#00B8F8"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.4be7dd5e.svg";
export { ForwardRef as ReactComponent };